// NPS Modal JavaScript
class NpsModal {
  constructor() {
    this.modal = null;
    this.selectedScore = null;
    this.init();
  }

  init() {
    this.bindEvents();
    this.checkAndShowModal();
  }

  bindEvents() {
    // Bind score selection
    $(document).on('change', 'input[name="nps_score"]', (e) => {
      this.selectedScore = parseInt(e.target.value);
      this.updateSubmitButton();
    });

    // Bind submit button
    $(document).on('click', '#submitNps', (e) => {
      e.preventDefault();
      this.submitNps();
    });

    // Bind modal close events
    $(document).on('click', '.nps-modal-close', () => {
      this.hideModal();
      this.dismissModal();
    });

    // Bind feedback textarea
    $(document).on('input', '#nps_feedback', () => {
      this.updateSubmitButton();
    });
  }

  checkAndShowModal() {
    // Check if we should show the modal
    $.get('/chiefs/nps_responses/can_show', (response) => {
      if (response.can_show) {
        this.showModal();
      }
    }).fail((xhr) => {
      console.log('NPS endpoint not available or error:', xhr.status);
      // Don't show modal if endpoint fails
    });
  }

  showModal() {
    const modalContainer = document.getElementById('npsModalContainer');
    
    if (modalContainer) {
      modalContainer.style.display = 'block';
      modalContainer.style.opacity = '0';
      modalContainer.style.transform = 'translateY(20px)';
      
      // Animação de entrada
      setTimeout(() => {
        modalContainer.style.transition = 'all 0.3s ease';
        modalContainer.style.opacity = '1';
        modalContainer.style.transform = 'translateY(0)';
      }, 10);
    }
  }

  updateSubmitButton() {
    const submitBtn = $('#submitNps');
    
    if (this.selectedScore !== null) {
      submitBtn.prop('disabled', false);
    } else {
      submitBtn.prop('disabled', true);
    }
  }

  submitNps() {
    if (this.selectedScore === null) {
      alert('Por favor, selecione uma nota de 0 a 10.');
      return;
    }

    const feedback = $('#nps_feedback').val().trim();
    const submitBtn = $('#submitNps');
    
    // Disable button and show loading
    submitBtn.prop('disabled', true);
    submitBtn.html('<i class="fa fa-spinner fa-spin"></i> Enviando...');

    const data = {
      nps_response: {
        score: this.selectedScore,
        feedback: feedback
      }
    };

    $.ajax({
      url: '/chiefs/nps_responses',
      method: 'POST',
      data: data,
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      success: (response) => {
        this.showSuccessMessage();
        this.hideModal();
      },
      error: (xhr) => {
        const errors = xhr.responseJSON?.errors || ['Erro ao enviar feedback'];
        alert('Erro: ' + errors.join(', '));
        
        // Re-enable button
        submitBtn.prop('disabled', false);
        submitBtn.html('Enviar');
      }
    });
  }

  dismissModal() {
    $.ajax({
      url: '/chiefs/nps_responses/dismiss',
      method: 'POST',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      }
    }).fail(() => {
      // Silently fail if dismiss doesn't work
    });
  }

  hideModal() {
    const modalContainer = document.getElementById('npsModalContainer');
    if (modalContainer) {
      modalContainer.style.transition = 'all 0.3s ease';
      modalContainer.style.opacity = '0';
      modalContainer.style.transform = 'translateY(20px)';
      
      setTimeout(() => {
        modalContainer.style.display = 'none';
      }, 300);
    }
  }

  showSuccessMessage() {
    // You can customize this success message
    const alertHtml = `
      <div class="alert alert-success alert-dismissible fade show" role="alert">
        <strong>Obrigado!</strong> Seu feedback foi enviado com sucesso.
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
    `;
    
    // Insert at the top of the page
    $('body').prepend(alertHtml);
    
    // Auto-hide after 5 seconds
    setTimeout(() => {
      $('.alert-success').fadeOut();
    }, 5000);
  }
}

// Initialize when document is ready
$(document).ready(() => {
  new NpsModal();
});
